import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const PROFILE_MGMT_URLS: generalConst = {
  BASE: ROUTES.PROFILE_MGMT,
  SECURITY_QUESTIONS: `${ROUTES.PROFILE_MGMT}/security-questions`,
};

export const STATE_IDENTIFIER = {
  PROFILE_MGMT: "profileManagement",
  SECURITY_QUESTIONS_MGMT: "securityQuestionsManagement",
  SECURITY_QUESTIONS: "securityQuestions",
  ID: "id",
  OLD_ID: "oldId",
  ANSWER: "answer",
  QUESTION: "securityQuestion",
  IS_DEF: "defaultQuestion",
  MISSING_QUESTIONS: "missingQuestions",
  CONFIG: "configuration",
  CONFIGS: "configurations",
  DEFAULT_QUESTIONS: "defaultQuestions",
  REQUEST_STATE: "requestState",
  ORIGINAL_SECURITY_QUESTIONS: "originalSecurityQuestions",
};
